import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import {
  DomainsForTableDTO,
  DomainSortByDTO,
} from 'features/inventory/domain/components/DomainsTable/types/api'
import {
  DomainsForTable,
  DomainSortBy,
} from 'features/inventory/domain/components/DomainsTable/types/model'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'

type From = DomainsForTableDTO
type To = DomainsForTable

export const domainsFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((domainForTable: From): To => {
    const { alerts, domainUnfilledRecovery, updatedAt } = domainForTable

    return {
      ...domainForTable,
      alerts: alertsFromDTO<DomainAlert>(alerts),
      domainUnfilledRecovery: {
        baseAdUnitPath: domainUnfilledRecovery.baseAdUnitPath ?? undefined,
      },
      updatedAt: new Date(updatedAt),
    }
  })

export const sortToDTO = (sort: SortInput<DomainSortBy>): SortInput<DomainSortByDTO> => {
  const { by } = sort

  if (by === 'name') {
    return { ...sort, by: 'domainName' }
  } else {
    return { ...sort, by }
  }
}
